import axios from 'axios'

/** Request Prettier formatting for the given file content. */
export async function formatFile(content: string, filePath: string): Promise<string> {
  const { data } = await axios.post('/node-api/format', { content, filePath })
  return data.formatted as string
}

/** Trigger on-demand LESS compilation for a single file. */
export async function compileLess(lessFilePath: string): Promise<{ cssPath: string }> {
  const { data } = await axios.post('/node-api/compile/less', { lessFilePath })
  return data as { cssPath: string }
}
